import React from 'react';
import VersionsChip from '@/components/OrderPlacement/OPStep2FileSelection/TitleBrowser/VersionChip';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { styled, Typography } from '@mui/material';
import { FocusTheme } from '@/components/Focus/configs/theme';
import ScheduleAvailChipButton from '../../ScheduleAvailChipButton';

type ChipItem = { label: string; value: string };

export type DeleteDialogScheduleItem = {
  key: string;
  icon: React.ReactNode;
  availCount: number;
  items: ChipItem[];
  selectedValues: string[];
};

export type ReviewScheduleDeleteDialogSummaryProps = {
  startDateLabel: string;
  season: string;
  versionType: string;
  episodeName: string;
  scheduleItems: DeleteDialogScheduleItem[];
};

const ReviewScheduleDeleteDialogSummary = ({
  startDateLabel,
  season,
  versionType,
  episodeName,
  scheduleItems
}: ReviewScheduleDeleteDialogSummaryProps) => {
  return (
    <StyledDeleteDialogSummaryRow>
      <StyledDeleteDialogTop>
        <StyledDeleteDialogDateRow>
          <StyledCalendarIcon icon="calendar" height={16} />
          <StyledDeleteDialogDateText>{startDateLabel}</StyledDeleteDialogDateText>
        </StyledDeleteDialogDateRow>
        <StyledDeleteDialogMetaRow>
          <StyledVersionText>{season}</StyledVersionText>
          <VersionsChip versionName={versionType} />
        </StyledDeleteDialogMetaRow>
        <StyledDeleteDialogEpisodeName>{episodeName}</StyledDeleteDialogEpisodeName>
      </StyledDeleteDialogTop>
      <StyledDeleteDialogAvailRow>
        {scheduleItems.map((item) => (
          <StyledDeleteDialogScheduleItemWrapper key={item.key}>
            <ScheduleAvailChipButton icon={item.icon} caption={item.availCount} items={item.items} />
          </StyledDeleteDialogScheduleItemWrapper>
        ))}
      </StyledDeleteDialogAvailRow>
    </StyledDeleteDialogSummaryRow>
  );
};

export default ReviewScheduleDeleteDialogSummary;

const StyledCalendarIcon = styled(PolarisIcon)`
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[20]};
`;

const StyledVersionText = styled(Typography)`
  font-size: 16px;
  line-height: 1.2;
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[20]};
`;

const StyledDeleteDialogSummaryRow = styled('div')`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const StyledDeleteDialogTop = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.75)};
`;

const StyledDeleteDialogDateRow = styled('div')`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const StyledDeleteDialogDateText = styled(Typography)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.common.white};
`;

const StyledDeleteDialogMetaRow = styled('div')`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const StyledDeleteDialogEpisodeName = styled(Typography)`
  font-size: 14px;
`;

const StyledDeleteDialogAvailRow = styled('div')`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
`;

const StyledDeleteDialogScheduleItemWrapper = styled('div')`
  transform: scale(0.85);
  transform-origin: left center;

  .MuiTypography-root {
    font-size: 12px;
  }
`;
